import { ShortlistActionMenuButton, useCurrentShortlist } from '@statsbomb/kitbag-shortlists';
import { atom } from 'jotai';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { EntityTopBar } from '@/components/topBar/EntityTopBar';
import { DEFAULT_RECRUITMENT_LIST_BASE_ROUTE } from '@/hooks/navigation/useRecruitmentListNavigationItem';
import { AppShellContents } from '../AppShell';

export const RecruitmentListPlayersLayout = () => {
  const { currentShortlist, currentShortlistName, isLoadingCurrentShortlist } = useCurrentShortlist();
  const translatedNameAtom = useMemo(() => atom(() => currentShortlistName), [currentShortlistName]);
  const navigate = useNavigate();
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <AppShellContents
      topBar={
        <EntityTopBar
          isLoading={isLoadingCurrentShortlist}
          selectedEntityNameAtom={translatedNameAtom}
          actions={
            <ShortlistActionMenuButton
              shortlist={currentShortlist}
              onArchiveSuccess={() => navigate(`/${language}${DEFAULT_RECRUITMENT_LIST_BASE_ROUTE}/overview`)}
            />
          }
        />
      }
    >
      <Outlet />
    </AppShellContents>
  );
};
